import { StaffExpensesSalaryIdsInput } from '../../lib/types/models/travel-expenses/travel-expenses'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const validateStaffsExpensesSalaries = async (input: StaffExpensesSalaryIdsInput) => {
  return restApiClient.url(API.travelExpenses.validateStaffsExpensesSalaries.url).post(input)
}
